import React from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import LeadForm from '../components/LeadForm';
import PersonCard from '../components/PersonCard';

export default function LeadCapture() {
  const location = useLocation();
  const navigate = useNavigate();
  const { person, searchTerm } = location.state || {};

  if (!person) {
    return <Navigate to="/" replace />;
  }

  const handleSuccess = (lead) => {
    navigate('/resultado', {
      state: { person, lead, searchTerm },
      replace: true,
    });
  };

  return (
    <div className="lead-page">
      <div className="container">
        <span className="back-link" onClick={() => navigate(-1)}>← Voltar</span>
        <div className="two-columns">
          <LeadForm
            person={person}
            searchTerm={searchTerm}
            onSuccess={handleSuccess}
          />
          <PersonCard person={person} hideDetails />
        </div>
      </div>
    </div>
  );
}
